import { useState } from 'react';
import { Link } from 'react-router-dom';
import { IconButton, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ClearIcon from '@mui/icons-material/Clear';
import { useAuth } from '../../contexts';
import Sun from '../../images/sun.png';
import './header-footer.scss';

export const MobileMenu = ({ handleSignUp }) => {
    const { user } = useAuth();
    const [showMenu, setShowMenu] = useState(false);
    const handleShowMenu = () => setShowMenu(!showMenu);

    return (
        <div className='mob-menu_wrapper'>
            <div className='logo'>
                <Link to={'/'}>
                    <img src={Sun} alt='weather' className='logo-image' />
                </Link>
                <h3>Погода в Україні та поради</h3>
            </div>
            <IconButton onClick={handleShowMenu}>
                <MenuIcon />
            </IconButton>
            {showMenu &&
                <div className='mob-menu_links'>
                    <IconButton sx={{ alignSelf: 'end' }} onClick={handleShowMenu}>
                        <ClearIcon />
                    </IconButton>
                    {user &&
                        <h3 className='header-login_user-name'>{user.email}</h3>
                    }
                    <Link to={'/'} className='btn-furure mob-menu_link' onClick={handleShowMenu}>
                        Головна
                    </Link>
                    {user ?
                        <>
                            <Link to={`/children`} className='btn-furure mob-menu_link' onClick={handleShowMenu}>
                                Список дітей
                            </Link>
                            <Button variant='contained'
                                sx={{
                                    width: '100%',
                                    backgroundColor: '#6565f5',
                                    boxShadow: 'none',
                                    fontSize: '18px',
                                    lineHeight: '1.4',
                                    textTransform: 'none',
                                    '&:hover': { backgroundColor: '#4d4de9' }
                                }}
                                onClick={() => {
                                    handleSignUp();
                                    setShowMenu(false);
                                }}>
                                Вийти
                            </Button>
                        </>
                        :
                        <>
                            <Link to={`/login`} className='btn-furure mob-menu_link' onClick={handleShowMenu}>
                                Зареєструватися
                            </Link>
                            <Link to={`/sign`} className='btn-furure mob-menu_link' onClick={handleShowMenu}>
                                Увійти
                            </Link>
                        </>
                    }
                </div>
            }
        </div>
    )
}